var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"premium-indicator",class:_vm.size,attrs:{"data-test":"premium-indicator"}},[_c('img',{attrs:{"src":require("../assets/images/premium_indicator.svg"),"alt":"Premium"}})])}
var staticRenderFns = []

export { render, staticRenderFns }